import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './components/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import FirmwareList from './pages/FirmwareList';
import FirmwareUpload from './pages/FirmwareUpload';
import DeviceList from './pages/DeviceList';
import PublishHistory from './pages/PublishHistory';
import FleetStatus from './pages/FleetStatus';
import Settings from './pages/Settings';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Protected routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="firmware" element={<FirmwareList />} />
            <Route path="firmware/upload" element={
              <ProtectedRoute requiredLevel={5}>
                <FirmwareUpload />
              </ProtectedRoute>
            } />
            <Route path="devices" element={<DeviceList />} />
            <Route path="fleet" element={<FleetStatus />} />
            <Route path="firmware/publish-history" element={<PublishHistory />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          
          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;